import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback';
import { classNames } from '../../utils';

interface InputProps
  extends Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'className' | 'value' | 'onChange'
  > {}

interface Props {
  title?: string;
  input?: InputProps;
  value?: string;
  readOnly?: boolean;
  className?: string;
  debounce?: boolean;
  onChange?: (color: string) => void;
}

export default function ColorPickerField({
  title,
  input,
  value,
  readOnly,
  className,
  debounce,
  onChange,
}: Props) {
  const debouncedOnChange = useDebouncedCallback(
    onChange ?? (() => {}),
    debounce ? 1000 : 0,
  );

  return (
    <div>
      {title ? (
        <label
          htmlFor="email"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          {title}
        </label>
      ) : (
        <></>
      )}

      <div
        className={classNames(
          'h-12 w-12',
          'overflow-hidden',
          'relative block rounded-md border-0 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600',
          className,
        )}
      >
        <input
          {...input}
          type="color"
          value={value}
          onChange={(e) => debouncedOnChange(e.target.value)}
          readOnly={readOnly}
          className="h-full w-full cursor-pointer"
        />
      </div>
    </div>
  );
}
